{
  "add_innovations.cancel_cta": "Cancel",
  "add_innovations.do_not_overwrite": "(The first line of the file must remain unchanged)",
  "add_innovations.download_example": "Download a CSV file example",
  "add_innovations.ean_fields": "EAN",
  "add_innovations.import_button": "Import a list (.csv)",
  "add_innovations.save_button": "Save innovations",
  "add_innovations.search_placeholder": "Type in at least 4 letters to filter results",
  "add_innovations.success_toaster": "Your innovations have been successfully added",
  "add_innovations.unknown_list_plural_and_other": "and {{variable2}} other",
  "add_innovations.unknown_list_plural_and_others": "and {{variable2}} others",
  "add_innovations.unknown_list_plural": "The references {{variable1}} have no data as they are not sold yet or could be incorrect.",
  "add_innovations.unknown_list_singular": "The reference {{variable}} has no data as it is not sold yet or could be inccorect.",
  "common_label.error_data": "-",
  "common_label.error_message": "An unknown error prevented the page from loading.",
  "delete_cta": "Delete",
  "delete_toaster_info": "Your innovation has been successfully deleted",
  "error_page.back_button": "Go back to Innovations",
  "error_page.generic_subtitle": "This page might not exist, might have been removed, or you may not have the right permissions. If you think this is a mistake, please contact your administrator.",
  "error_page.generic_title": "Sorry, you do not have access to this page",
  "error_page.no_access_subtitle": "If you think this is a mistake, please contact your administrator.",
  "error_page.no_access_title": "Sorry, you do not have access to the Innovations monitoring tool",
  "inno_navbar.gitbook_button": "Contact us",
  "inno_navbar.gitbook_tooltip": "Access user guide",
  "inno_navbar.module_name": "Innovations monitoring",
  "inno_navbar.title": "Carrefour Links",
  "inno_navbar.utilities": "Utilities",
  "inno_page_subtitle": "Maximize your success potential with accurate data and adapt your strategy",
  "inno_page_table_name": "All your innovations",
  "inno_page_title": "Innovations monitoring",
  "inno_page.add_button": "Add innovations",
  "inno_page.date_selector_apply": "Apply selection",
  "inno_page.date_selector_end": "End date",
  "inno_page.date_selector_start": "Start date",
  "inno_page.date_selector_title": "Time interval for the analysis",
  "inno_page.export_button": "Export to csv",
  "inno_page.export_no_data_warning": "No available data to export",
  "inno_page.format_filters_all": "All",
  "inno_page.format_filters_format": "Formats",
  "inno_page.supplier_filters_all": "All",
  "inno_page.supplier_filters": "Suppliers",
  "inno_reporting_email.cta_link": "Check all your performance data",
  "inno_reporting_email.period_reminder_from": "From",
  "inno_reporting_email.period_reminder_launch_date": "launch date",
  "inno_reporting_email.period_reminder_subtitle_previous": "previous week",
  "inno_reporting_email.period_reminder_subtitle": "Evolution since",
  "inno_reporting_email.period_reminder_to": "to",
  "inno_reporting_email.table_column_detention": "Possession rate on sales",
  "inno_reporting_email.table_column_EAN": "Innovation",
  "inno_reporting_email.table_column_VMH": "Av. weekly sales / Objective",
  "inno_reporting_email.table_title": "All your innovations - Evolutions since last week",
  "inno_reporting_email.title": "Innovations activity summary",
  "inno_reporting_email.top_flop_detention.title": "Biggest detention changes since last week",
  "inno_reporting_email.top_flop_sales.subtitle": "Average weekly sales since launch",
  "inno_reporting_email.top_flop_sales.title": "Biggest sales changes since last week (quantity)",
  "inno_reporting_email.top_flop_since_last_week": "since last week",
  "inno_topbar.logout_button": "Disconnect",
  "listing_table_column_name_ean": "EAN",
  "listing_table_column_name_format": "Format",
  "listing_table_column_name_goal": "Goal progress",
  "listing_table_column_name_label": "Label",
  "listing_table_column_name_launch_date": "Launchdate",
  "listing_table_column_name_posession_rate": "Possession rate on sales",
  "listing_table_column_name_product_name": "Product",
  "listing_table_column_name_subfam_weekly_sales": "Sub-family average weekly sales (quantity)",
  "listing_table_column_name_supplier": "Supplier",
  "listing_table_column_name_weekly_sales": "Average weekly sales (quantity)",
  "monitoring_page.back_button": "Back to your innovations list",
  "monitoring_page.graph.copy_image_message": "Succesfully copied in your clipboard",
  "monitoring_page.graph.copy_image": "Copy graph as image",
  "monitoring_page.graph.extract_csv": "Extract data in csv",
  "monitoring_page.graph.legend_innovation": "Average weekly sales (quantity)",
  "monitoring_page.graph.legend_possesion_rate": "Possession rate on sales (%)",
  "monitoring_page.graph.legend_subclass": "Sub-family average weekly sales (quantity)",
  "monitoring_page.graph.save_image": "Save graph as image",
  "monitoring_page.graph.title": "Innovation performance",
  "monitoring_page.internal_search_field": "Search by EAN or product name",
  "monitoring_page.internal_search_no_result": "No result for",
  "monitoring_page.metadata_date_perimeter": "From {{launchDate}} to {{today}}",
  "monitoring_page.metadata_launchdate": "Launched on",
  "monitoring_page.no_target_quantity": "This innovation has no available data for the average weekly sales quantity target.",
  "monitoring_page.not_shared_with_alert": "Carrefour view only",
  "monitoring_page.objective_card_description": "Average weekly sales (units): {{averageWeeklySalesQuantity}}/{{averageWeeklySalesQuantityGoal}}",
  "monitoring_page.objective_card_title": "You have achieved {{achieved_objective_percent}} of your objective",
  "monitoring_page.shared_with_alert": "Shared with {supplier_name}",
  "monitoring_page.store_detention_alert_export": "Extract store list in CSV ({{store_count}})",
  "monitoring_page.store_detention_alert_plural": "stores are expected to sell this item but they do not",
  "monitoring_page.store_detention_alert_singular": "store is expected to sell this item but it does not",
  "monitoring_page.tab_name_quant": "Quantity",
  "monitoring_page.tab_name_value": "Sales w/ tax",
  "monitoring_page.tabs.quant.left_side_objective": "Goal",
  "monitoring_page.tabs.quant.left_side_title": "Average weekly sales (units)",
  "monitoring_page.tabs.quant.right_side_non_promo": "Non-promo",
  "monitoring_page.tabs.quant.right_side_promo": "Promo.",
  "monitoring_page.tabs.quant.right_side_title": "Total since launch",
  "monitoring_page.tabs.value_right_side_title": "Total since launch (w/ tax)",
  "monitoring_page.tabs.value.left_side_title": "Average weekly sales (w/ tax)",
  "monitoring_page.tabs.value.right_side_non_promo": "Promo.",
  "monitoring_page.tabs.value.right_side_promo": "Non-promo",
  "unsubscribe_page.cta_confirm": "Confirm & unsubscribe",
  "unsubscribe_page.main_subtext": "You can resubscribe at any time by contacting our support team.",
  "unsubscribe_page.main_text": "You are about to unsubscribe from the innovations weekly report",
  "unsubscribe_page.question": "Any question?",
  "unsubscribe_page.successful_text": "You are now unsubscribed from the innovations weekly report",
  "unsubscribe_page.support": "Contact our support team"
}
